import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import AsesmenGadarMedisSvc from "@/services/AsesmenAwalGadarMedisAltSql";
import { isEmpty } from "lodash";
import {
  AsesmenAwalGadarMedisResp,
  AsesmenAwalGadarMedisRequestParams
} from "@/types/asesmen_gawat_darurat";

@Module({ dynamic: true, namespaced: true, store, name: "asesmen-gadar-medis" })
class AsesmenGadarMedisStore extends VuexModule {
  loading = false;
  asesmen: AsesmenAwalGadarMedisResp = null;

  inputFields: AsesmenAwalGadarMedisRequestParams = null;

  registerId: string = null;

  @Mutation
  SET_ASESMEN(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_INPUT_FIELDS(val) {
    this.inputFields = val;
  }

  @Mutation
  SET_REGISTER_ID(val) {
    this.registerId = val == null ? null : String(val);
  }

  @Mutation
  CLEAR_STORE() {
    this.asesmen = null;
    this.inputFields = null;
    this.registerId = null;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    if (this.registerId !== String(registerId)) {
      this.SET_ASESMEN(null);
    }

    this.SET_REGISTER_ID(registerId);

    const response = await AsesmenGadarMedisSvc.getByRegister(
      registerId
    ).finally(() => {
      this.SET_LOADING(false);
    });

    if (this.registerId !== String(registerId)) return;

    const data = isEmpty(response.data?.data) ? null : response.data.data;

    this.SET_ASESMEN(data);
  }

  @Action({ rawError: true })
  async getById(id): Promise<void> {
    this.SET_LOADING(true);

    const response = await AsesmenGadarMedisSvc.find(id).finally(() => {
      this.SET_LOADING(false);
    });

    const data = isEmpty(response.data?.data) ? null : response.data.data;

    this.SET_ASESMEN(data);
  }

  @Action({ rawError: true })
  clear(): void {
    this.CLEAR_STORE();
  }
}

export default getModule(AsesmenGadarMedisStore);
